window.MarguetProductCards = window.MarguetProductCards || {

  initCard: function(card) {
    if (card.dataset.marguetInitialized === "true") return;
    card.dataset.marguetInitialized = "true";

    // Metalware — ordre corrigé : classes d'abord, clic ensuite
    const radios = card.querySelectorAll('[name^="metalware-"]');
    radios.forEach(radio => {
      radio.addEventListener('change', function(e) {
        const selectedMetalware = e.target.value;
        const items = card.querySelectorAll('.color-item');

        items.forEach(item => {
          const match = item.getAttribute('data-metalware') === selectedMetalware;
          item.classList.toggle('hidden', !match);
          item.classList.toggle('visible', match);
        });

        const firstVisible = card.querySelector('.color-item[data-metalware="' + selectedMetalware + '"]:not(.hidden)');
        if (firstVisible) firstVisible.click();
      });
    });

    // Changement image au clic couleur
    // Pas de data-srcset disponible donc srcset = '' est nécessaire
    const primaryImage = card.querySelector('.product-card__media .product-card__image--primary');
    const secondaryImage = card.querySelector('.product-card__media .product-card__image--secondary');
    card.querySelectorAll('.color-item').forEach(item => {
      item.addEventListener('click', function() {
        if (primaryImage) {
          primaryImage.src = item.getAttribute('data-variant-media') || primaryImage.src;
          primaryImage.srcset = '';
        }
        if (secondaryImage) {
          secondaryImage.src = item.getAttribute('data-variant-secondary-media') || secondaryImage.src;
          secondaryImage.srcset = '';
        }
      });
    });

    // Flèches défilement swatches
    const scrollAmount = 200;
    const prevBtn = card.querySelector(".swiper-button-prev");
    const nextBtn = card.querySelector(".swiper-button-next");
    const wrapper = card.querySelector(".swiper-container .swiper-wrapper");
    if (prevBtn && wrapper) prevBtn.addEventListener("click", function() { wrapper.scrollLeft -= scrollAmount; });
    if (nextBtn && wrapper) nextBtn.addEventListener("click", function() { wrapper.scrollLeft += scrollAmount; });
  },

  init: function() {
    document.querySelectorAll('.product-card').forEach(card => {
      this.initCard(card);
    });
  }
};

document.addEventListener("DOMContentLoaded", function() {
  window.MarguetProductCards.init();
});

document.addEventListener("shopify:section:load", function() {
  window.MarguetProductCards.init();
});